import { Injectable } from '@angular/core';

// export interface types {
//   datatable: string;
//   grid: string;
//   page: string;
//   card: string;
//   gantt: string;
//   map: string;
//   calendar: string;
//   button: string;
//   link: string;
// }

@Injectable({
  providedIn: 'root',
})
export class TabsDataService {
  tabDataCash: any = {
    datatable: {},
    grid: {},
    page: {},
    card: {},
    gantt: {},
    map: {},
    calendar: {},
    button: {},
    link: {},
    formKeys: {},
  };
  constructor() {}
  setData(id: string, data: any, type: string) {
    this.tabDataCash[type][id] = data;
  }
  getData(id: string, type: string) {
    return this.tabDataCash[type][id];
  }

  resetData() {
    this.tabDataCash = {
      datatable: {},
      grid: {},
      page: {},
      card: {},
      gantt: {},
      map: {},
      calendar: {},
      button: {},
      link: {},
      formKeys: {},
    };
  }
}
